/**
 * Reduer for email templates
 */
import get from 'lodash/get';
import {
  FETCH_PROMOTION_REQUESTS,
  UPDATE_PROMOTION_REQUEST,
  RESET_PROMOTION_REQUEST_REDUCER,
} from '../actions/actionTypes';
import { updateItemInItems } from '../../utils';

const initialState = {
  requests: [],
  isLoading: false,
  hasUpdate: false,
  page: 1,
  limit: 10
};

export const requestSelector = (state) => get(state, 'promotionRequests', []);
const requestReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROMOTION_REQUESTS:
      return { ...state, ...action.data };
    case UPDATE_PROMOTION_REQUEST:
      return updatedRequests(state, action);
    case RESET_PROMOTION_REQUEST_REDUCER:
      return initialState;
    default:
      return state;
  }
};

const updatedRequests = (state, action) => {
  const { request, ...rest } = action.data;
  if (request) {
    const { index, status } = request;
    return {
      ...state,
      requests: updateItemInItems(state.requests, index, { status }),
      ...rest
    };
  }
  return { ...state, ...action.data };
};
export default requestReducer;
